// @flow
export const AGREE_TO_PAY_ON_TERM = 'checkout/payment/AGREE_TO_PAY_ON_TERM';
export const agreeToPayOnTerm = (payload: boolean) => ({
  type: AGREE_TO_PAY_ON_TERM,
  payload,
});
